/** Услуга с полями оффера / счёта (из каталога или с API счёта). */
export type EuAccountGoalLike = {
    goal_revenue_type?: string | null;
    payout_type?: string | null;
};

export function isEuAccountPercentGoal(item: EuAccountGoalLike): boolean {
    const t = item.goal_revenue_type;
    if (t === 'cpa_percentage' || t === 'percent') return true;
    if (item.payout_type === 'percent') return true;
    return false;
}

export function isEuAccountFixedGoal(item: EuAccountGoalLike): boolean {
    if (isEuAccountPercentGoal(item)) return false;
    const t = item.goal_revenue_type;
    if (t === 'cpa_flat' || t === 'fixed') return true;
    if (item.payout_type === 'fixed') return true;
    return false;
}
